/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ReverseGeocodingConfigurationResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ReverseGeocodingConfigurationResource model module.
   * @module model/ReverseGeocodingConfigurationResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ReverseGeocodingConfigurationResource</code>.
   * The configurations for the reverse geocoding.
   * @alias module:model/ReverseGeocodingConfigurationResource
   * @class
   * @param connectionString {String} The ConnectionString for the database.
   */
  var exports = function(connectionString) {
    var _this = this;

    _this['connectionString'] = connectionString;
  };

  /**
   * Constructs a <code>ReverseGeocodingConfigurationResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ReverseGeocodingConfigurationResource} obj Optional instance to populate.
   * @return {module:model/ReverseGeocodingConfigurationResource} The populated <code>ReverseGeocodingConfigurationResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('connectionString')) {
        obj['connectionString'] = ApiClient.convertToType(data['connectionString'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ConnectionString for the database.
   * @member {String} connectionString
   */
  exports.prototype['connectionString'] = undefined;



  return exports;
}));



